/**
 * RepOcean Google Reviews — barra de progreso INFINITY
 * Respeta show_nav_arrows (RepOcean) y show_progress_bar (section SS RepOcean INFINITY).
 */
(function () {
  var SECTION_FRAGMENT = '17442250271b710cc5';

  function getThemeConfig() {
    var configEl = document.querySelector('[data-repocean-infinity-config]');
    if (!configEl) return { showProgressBar: true };

    return {
      showProgressBar: configEl.getAttribute('data-show-progress-bar') !== 'false',
    };
  }

  function getRepOceanConfig(reviewsRoot) {
    if (!reviewsRoot) return { showNavArrows: false };

    try {
      var raw = reviewsRoot.getAttribute('data-config');
      if (!raw) return { showNavArrows: false };
      return JSON.parse(raw);
    } catch (error) {
      return { showNavArrows: false };
    }
  }

  function getTranslateX(track) {
    if (!track) return 0;

    var inline = track.style.transform;
    if (inline && inline !== 'none') {
      var translate3d = inline.match(/translate3d\(\s*(-?[\d.]+)px/i);
      if (translate3d) return Math.abs(parseFloat(translate3d[1]));

      var translateX = inline.match(/translateX\(\s*(-?[\d.]+)px/i);
      if (translateX) return Math.abs(parseFloat(translateX[1]));
    }

    var matrix = window.getComputedStyle(track).transform;
    if (!matrix || matrix === 'none') return 0;

    var values = matrix.match(/-?[\d.]+/g);
    if (!values || values.length < 6) return 0;

    return Math.abs(parseFloat(values[4]));
  }

  function applyNavMode(section, showNavArrows) {
    section.classList.toggle('repocean-infinity--no-arrows', !showNavArrows);
    section.classList.toggle('repocean-infinity--has-arrows', !!showNavArrows);
  }

  function teardownProgress(section) {
    var progress = section.querySelector('[data-repocean-progress]');
    if (progress) progress.remove();

    if (section.__repoceanInfinityStop) {
      section.__repoceanInfinityStop();
      section.__repoceanInfinityStop = null;
    }
  }

  function setupProgress(section, track, viewport) {
    var carouselArea = section.querySelector('.repocean-carousel-area');
    if (!track || !carouselArea) return;

    teardownProgress(section);

    var progress = document.createElement('div');
    progress.className = 'repocean-infinity-progress';
    progress.setAttribute('data-repocean-progress', '');
    progress.setAttribute('aria-hidden', 'true');
    progress.innerHTML =
      '<div class="repocean-infinity-progress__fill" data-repocean-progress-fill></div>';

    carouselArea.appendChild(progress);

    var fill = progress.querySelector('[data-repocean-progress-fill]');
    var rafId = null;

    function updateProgress() {
      var cards = track.querySelectorAll('.repocean-card');
      if (!cards.length || !fill) return;

      var cardWidth = cards[0].offsetWidth;
      var trackStyle = window.getComputedStyle(track);
      var gap =
        parseFloat(trackStyle.gap) ||
        parseFloat(trackStyle.columnGap) ||
        parseFloat(window.getComputedStyle(cards[0]).marginRight) ||
        0;
      var step = cardWidth + gap;
      var totalWidth = step * cards.length;
      var viewportWidth = viewport ? viewport.clientWidth : cardWidth;
      var translateX = getTranslateX(track);

      if (totalWidth <= viewportWidth) {
        fill.style.width = '100%';
        return;
      }

      var progressValue = ((translateX + viewportWidth) / totalWidth) * 100;
      fill.style.width = Math.min(100, Math.max(0, progressValue)) + '%';
    }

    function startLoop() {
      if (rafId) return;

      function tick() {
        updateProgress();
        rafId = window.requestAnimationFrame(tick);
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function stopLoop() {
      if (!rafId) return;
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    startLoop();

    var styleObserver = new MutationObserver(updateProgress);
    styleObserver.observe(track, { attributes: true, attributeFilter: ['style'] });

    var cardsObserver = new MutationObserver(function () {
      updateProgress();
      startLoop();
    });
    cardsObserver.observe(track, { childList: true });

    window.addEventListener('resize', updateProgress);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateProgress).observe(track);
      if (viewport) new ResizeObserver(updateProgress).observe(viewport);
    }

    section.__repoceanInfinityStop = stopLoop;
    updateProgress();
  }

  function initSection(section) {
    var reviewsRoot = section.querySelector('.repocean-reviews');
    var track = section.querySelector('.repocean-track');
    var viewport = section.querySelector('.repocean-viewport');
    var themeConfig = getThemeConfig();
    var repOceanConfig = getRepOceanConfig(reviewsRoot);
    var showNavArrows = !!repOceanConfig.show_nav_arrows;
    var showProgressBar = themeConfig.showProgressBar;

    applyNavMode(section, showNavArrows);
    section.classList.toggle('repocean-infinity--no-progress', !showProgressBar);

    if (!showProgressBar) {
      teardownProgress(section);
      return;
    }

    if (!track) {
      if (reviewsRoot && !section.__repoceanInfinityWait) {
        section.__repoceanInfinityWait = new MutationObserver(function () {
          var readyTrack = section.querySelector('.repocean-track');
          if (!readyTrack) return;
          section.__repoceanInfinityWait.disconnect();
          section.__repoceanInfinityWait = null;
          initSection(section);
        });
        section.__repoceanInfinityWait.observe(reviewsRoot, { childList: true, subtree: true });
      }
      return;
    }

    setupProgress(section, track, viewport);
  }

  function init() {
    document.querySelectorAll('[id*="' + SECTION_FRAGMENT + '"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
